import {
	getPlan,
	isMultiScenarioEnabled,
	getPlanScenarios,
	currentScenarioId,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/plan';
import { createSelector } from '@atlassian/jira-portfolio-3-portfolio/src/common/reselect';
import type { MapStateToProps } from '@atlassian/jira-portfolio-3-portfolio/src/common/types/redux';

import type { StateProps } from './types';

const getScenario = createSelector(
	[isMultiScenarioEnabled, getPlanScenarios, currentScenarioId],
	// eslint-disable-next-line @typescript-eslint/no-shadow
	(isMultiScenarioEnabled, scenarios, currentScenarioId) =>
		isMultiScenarioEnabled === true
			? (scenarios || []).find((scenario) => scenario.id === currentScenarioId)
			: undefined,
);

export const mapStateToProps: MapStateToProps<StateProps> = (state) => ({
	plan: getPlan(state),
	scenario: getScenario(state),
});
